import React from "react";

const ProgressBar = (props) => {
  const { pages, currentPage } = props;
  let statusBars = [];

  for (let i = 0; i < pages; i++) {
    statusBars.push(<div></div>);
  }

  return (
    <div>
      <ul className="flex w-screen justify-evenly text-3xl px-5 py-1">
        {statusBars.map((item, index) => {
          return (
            <li
              key={index}
              className="w-full h-2 text-black border-slate-300 border-1 m-0.5"
              style={{ background: currentPage > index ? "#BAF71F" : "" }}
            >
              {item}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProgressBar;
